<template>
    <div>
        <FilterTable 
          :resource_name="resource_name"
          :title="title"
          :field_definitions="field_definitions"
          :filters="filters"
          :action_buttons="action_buttons"
          :row_actions="row_actions"
          :translate_to_display_data="translate_to_display_data"
          :route_root="route_root"
          :handle_row_action="handle_row_action"
          :full_text_search="true"
          :handle_action_button_click="handle_action_button_click"
          :category_info="category_info"
          :button_trigger_search="false"
          :handle_table_action="handle_table_action"
          :table_actions="table_actions"
          :update_flag="filter_table_update_flag"
        />
        <LoadingBlock
          :active="loading">
        </LoadingBlock>
    </div>
</template>

<script>
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import api from '@/api/index'
import FilterTable from '@/components/backstage/FilterTable/FilterTable.vue'
import breadcrumbMixin from '@/mixins/breadcrumbMixin'
import articleExportMixin from '@/mixins/articleExportMixin'

  export default {
    mixins: [
      breadcrumbMixin,
      articleExportMixin
    ],
    components: {
      FilterTable,
      LoadingBlock,
    },
    data() {
      return {
        // 0.類型(公文/圖說(技術文件)/出版品/影像/文物器具/口述史料/文化自然景觀/建築物、土木設施與遺址類)
        // 1.全宗名(ex. 大元山)
        // 2.全宗號(ex. DY)
        // 3.單件題名(title)(ex. 世紀之森)
        // 4.對外授權(是/否) rights_outside
        // 5.是否有數位物件(是/否)
        // 6.狀態(毀損/良好)
        // 7.建立時間(YYYY-MM-DD)
        resource_name: "article",
        title: '整合查詢',
        route_root: 'integrated-search',
        field_definitions: [
          {
            display: {
              name: '編號',
              type: 'string',
              sortable: 'custom',
              width: '80px',
            },
            source: {
              type: 'db',
              key: 'system_id',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '類型',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'series_name',
              data_type: 'string',
            } 
          },
          {
            display: {
              name: '全宗名',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'recordgroup_name',
              data_type: 'string',
            }
          },
          {
            display: {
              name: '單件題名',
              type: 'string',
              sortable: 'custom',
              width: '400px',
            },
            source: {
              type: 'db',
              key: 'title',
              data_type: 'string',
            }
          },
          {
            display: {
              name: '建立時間',
              type: 'string',
              sortable: 'custom',
            },
            source: {
              type: 'db',
              key: 'article_created_time',
              data_type: 'datetime',
            }
          },
        ],
        filters: {
          // '全宗名': {
          //   paramName: 'fk_recordgroup_id',
          //   value: null,
          //   options: {
          //     list: [],
          //     type: 'db',
          //     endpoint: '/organization/list',
          //     params: [
          //       {
          //         name: 'hierarchy_name',
          //         type: 'fixed',
          //         form: 'json',
          //         value: 'recordgroup'
          //       }
          //     ],
          //     method: 'post',
          //     label: 'recordgroup_name',
          //     value: 'id'
          //   },
          // },
          // '資料類型': {
          //   paramName: 'series_number',
          //   value: null,
          //   options: {
          //     type: 'fixed',
          //     list: [
          //       { label: '公文類', value: '01' },
          //       { label: '圖說(技術文件)', value: '02' },
          //       { label: '出版品', value: '03' },
          //       { label: '影像', value: '04' },
          //       { label: '文物器具類', value: '05' },
          //       { label: '口述歷史類', value: '06' },
          //       { label: '文化、自然景觀類', value: '07' },
          //       { label: '建築物、土木設施與遺址類', value: '08' },
          //     ],
          //   },
          // },
        },
        category_info: {
          endpoint: 'article/post-classification/list',
          categories: [
            {
              title: '全宗',
              display: {
                name: 'recordgroup_name',
                type: 'string',
              },
              filter: {
                key: 'fk_recordgroup_id',
                type: 'string'
              },
            },
            {
              title: '類型',
              display: {
                name: 'series_name',
                type: 'string',
              },
              filter: {
                key: 'series_number',
                type: 'string'
              },
            },
            {
              title: '存放地點',
              display: {
                name: 'archive_location',
                type: 'string',
              },
              filter: {
                key: 'archive_location',
                type: 'string'
              },
            },
          ]
        },
        action_buttons: {
        },
        table_actions: {
          export_selected: {
            label: '匯出勾選項目',
            action: 'export-selected'
          },
          export_filtered: {
            label: '匯出搜尋結果',
            action: 'export-filtered'
          },
        },
        row_actions: {
          get: {
            label: '檢視',
            action: 'get'
          }
        },
        filter_table_update_flag: 0,
        loading: false
      }
    },
    methods: {
      translate_to_display_data(data) {
        let types = {}
        this.field_definitions.forEach(
          function (field) {
            types[field['source']['key']] = field['source']['data_type']
          })

        let translated_data = data
        
        for (let key in data) {
          if (types[key] === 'datetime' && data[key]) {
            translated_data[key] = data[key].date.slice(0,-7)
          }
        }
        
        
        return translated_data
      },
      handle_row_action (action, index, row) {
        console.log('IntegratedSerach: action:' + action + ', index: ' + index + ', row: ', row)

          switch(action){
            case 'get': 
                this.backstage_router_push({ path: `/${this.route_root}/${row.series_table_name}/view/${row.system_id}` })
                break
            default:
                break
          }
      },
      handle_action_button_click (action) {
        console.log('IntegratedSerach: action button clicked: ', action)

        switch(action){
          case 'export': 
              break
          default:
              break
        }
      },
      async handle_table_action ({action, selection, data, search_param}) {
        console.log('DigitalResourceManagementPage: action:', action , ', selection: ', selection, ', data: ', data)

        switch(action){
          case 'export-selected':
          case 'export-filtered':
              this.handle_table_export_action(action, selection, search_param)
            break
          default:
            console.warn('[WARN] Unhandled action=', action)
            break
        }
      },
      handle_table_update () {
        this.filter_table_update_flag += 1
      }
    }
  };
</script>

<style>
</style>
